module.exports = __webpack_public_path__ + "img/pagelist.0dbbaba1.svg";